'use client';
import { usePathname, useRouter } from 'next/navigation';
import { Container, Text, useTranslation } from '@weareconceptstudio/core';

//* Helper's
import { config } from '@/helpers';

//* Components
import Button from '@/components/Button';

//* Utils
import { errSVG } from './utils';

//* Style
import Custom404TemplateStyle from './style';
import { useEffect } from 'react';

const Custom404Template = () => {
	const { selectedLang } = useTranslation();

	//! Next Navigation
	const router = useRouter();
	const pathname = usePathname();

	//! Check
	useEffect(() => {
		if (!(pathname.replace(selectedLang + '/', '') == '/not-found/')) {
			router.push(`/${selectedLang}/not-found/`) || router.push(`/not-found/`);
		}
	}, [router, pathname, selectedLang]);

	return (
		<Custom404TemplateStyle>
			<Container
				row
				className={'error-container'}>
				<div className={`col-4 col-dx-3 col-m-12`} />
				<div className={`col-4 col-dx-6 col-m-12 main-wrapper align-center`}>
					<div className={`error-svg`}>{errSVG}</div>

					<Text
						tag={`h1`}
						className={`h4 funnel-600 title black700`}
						text={'404title'}
					/>

					<Text
						className={'p2 grotesk-400 description black700'}
						text={'404description'}
					/>

					<Button
						className={'btn'}
						btnType={'primary'}
						text={'goToHomepage'}
						url={config.routes.home.path}
					/>
				</div>
				<div className={`col-4 col-dx-3 col-m-12`} />
			</Container>
		</Custom404TemplateStyle>
	);
};

export default Custom404Template;
